import Vue from 'vue'

export async function signIn ({ commit }, user) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })

    const { data } = await Vue.axios({
      method: 'POST',
      url: '/v1/users/auth',
      data: user
    })

    commit('auth/login', data, { root: true })
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function signUp ({ commit }, user) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })

    await Vue.axios({
      method: 'POST',
      url: '/v1/users',
      data: user
    })
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function recoverAccount ({ commit }, user) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })

    const { data } = await Vue.axios({
      method: 'POST',
      url: '/v1/users/reset-password',
      data: user
    })

    return data
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function changePassword ({ commit }, user) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })

    const { data } = await Vue.axios({
      method: 'PUT',
      url: '/v1/users/reset-password',
      data: user
    })

    return data
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function signInGuest ({ commit }) {
  try {
    commit('shared/setError', false, { root: true })
    commit('shared/setLoading', true, { root: true })

    const { data } = await Vue.axios({
      method: 'POST',
      url: '/v1/users/guest-auth'
    })

    commit('auth/loginGuest', data, { root: true })
  } catch (error) {
    commit('shared/setError', error, { root: true })
  } finally {
    commit('shared/setLoading', false, { root: true })
  }
}

export async function logout ({ commit }) {
  commit('auth/logout', {}, { root: true })
  signInGuest({ commit })
}
